/**
 * src/components/hero/Hero.js
 *
 * Componente padre del hero. Orquesta contenido y media.
 * Los stats de confianza (trust) se leen de /data/site.json para que
 * sean editables desde el panel admin; el resto viene de hero.db.js.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { heroData } from '@/db/hero.db.js'

define('Hero', () => {
    const content = c('HeroContent', {
        headline:    heroData.headline,
        subheadline: heroData.subheadline,
        ctas:        heroData.ctas,
        trust:       heroData.trust
    })

    /* Actualiza los stats de confianza con los datos publicados desde el admin */
    fetch(`/data/site.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            if (!Array.isArray(data.trust) || !data.trust.length) return
            const wrap = content.querySelector('.hero-trust')
            if (!wrap) return
            wrap.innerHTML = ''
            data.trust.forEach(({ value, label }) => {
                wrap.appendChild(
                    h('div', { className: 'hero-trust__item' },
                        h('strong', { className: 'hero-trust__value' }, value),
                        h('span',   { className: 'hero-trust__label' }, label)
                    )
                )
            })
        })
        .catch(() => {})

    return h('section', { className: 'hero' },
        h('div', { className: 'hero__inner' },
            content,
            c('HeroMedia', heroData.media)
        )
    )
})
